import React, { useEffect, useState } from "react";
import { Grid, Button, Card } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import { FetchMotivosBajaEfector, agregarMotivoDeBaja, ModificarMotivoDeBaja, EliminarMotivoDeBaja, BuscarMotivoBaja} from "../../../../actions/contrataciones/configuraciones/abmMotivosBajaEfector";
import { CONFIGURACION_CONTRATOS } from "../../../../utils/permisos";
import ModalAbm from '../../../compartidos/abms/ModalAbm';
import BuscadorAbm from "../../../compartidos/abms/BuscadorAbm";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import AccionesGenericoAbm from "../../../compartidos/abms/AccionesGenericoAbm";
import { makeStyles } from "@material-ui/core/styles";
import { FormMotivosBajaEfector } from './FormMotivosBajaEfector';

const useStyles = makeStyles({
  botonera: {
    padding: 25
  }
});

export const HomeMotivosBajaEfector = (props) => {
  const { items } = useSelector((state) => state.motivosBajaEfector);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [MotivosBajaEfector, setMotivosBaja] = useState(false);
  const [openAlta, setMotivosAlta] = useState(false);

  useEffect(() => {
    dispatch(FetchMotivosBajaEfector());
  }, [dispatch]);

  const handleSearch = (textoBuscado) => {
    dispatch(BuscarMotivoBaja(textoBuscado));
  }

  const handleMotivosSelectSelect = (item) => {
    setMotivosBaja(item)
    setOpen(true)
  }

  const handleSave = (item) => {
    if (item.idMotivoBaja) {
      dispatch(ModificarMotivoDeBaja(item.idMotivoBaja, item));
    } else {
      dispatch(agregarMotivoDeBaja(item.descripcion));
    }
  };

  const handleDelete = (item) => {
    dispatch(EliminarMotivoDeBaja(item.idMotivoBaja)); 
  }

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Agregar Motivo de Baja" open={openAlta} setOpen={setMotivosAlta}>
          <FormMotivosBajaEfector MotivosBajaEfector={null} handleSave={handleSave} cerrarModal={() => setMotivosAlta(false)} permisoAlta={CONFIGURACION_CONTRATOS.ALTA}/>
        </ModalAbm>
        <ModalAbm title="Modificar Motivo de Baja" open={open} setOpen={setOpen}>
          <FormMotivosBajaEfector MotivosBajaEfector={MotivosBajaEfector} handleSave={handleSave} cerrarModal={() => setOpen(false)} permisoEdit={CONFIGURACION_CONTRATOS.MODIFICACION}/>
        </ModalAbm>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setMotivosAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Motivo de Baja</Button>
        </Grid>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar Motivo de Baja" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  label:"",
                  customBody:(item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handleMotivosSelectSelect}
                      permisoDelete={CONFIGURACION_CONTRATOS.BAJA}
                      handleDelete={handleDelete}
                    />
                  )
                },
                {
                  label: "Descripcion",
                  id: "descripcion",
                  sort: true
                }
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );

};

export default HomeMotivosBajaEfector; 
